import {
  dialogFlowIntentNames,
  goodDialogFromIntents
} from 'features/Engagement/constants'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import LoyaltyIcon from '../../Arrivals/LoyaltyIcon/index'
import styles from './ConversationRow.module.scss'
import { ReactComponent as RoomOffIcon } from './RoomKeyOff.svg'
import { ReactComponent as RoomOnIcon } from './RoomKeyOn.svg'

const MessageCount = ({ count }) => (
  <>
    {count > 1 ? (
      <div className={styles.countBubble}>{count > 9 ? '9+' : count}</div>
    ) : null}
  </>
)

const Preview = ({ active, lastMessage }) => {
  if (active) {
    return <span className={styles.yourConversation}>You are on this chat</span>
  }

  return <span>{lastMessage}</span>
}

const ConversationRow = ({
  subscriber,
  lastMessage,
  roomNumber,
  lastMessageOn,
  active,
  chatId,
  waitingMessageCount,
  chatCat,
  isCheckedOut = false,
  baseUrl,
  loyaltyLevel,
  loyaltyProgram,
  ownedBy,
  lastMessageBotIntent
}) => {
  moment.updateLocale(moment.locale(), { invalidDate: '' })

  return (
    <Link to={`${baseUrl}/${chatId}`}>
      <div
        className={[active ? styles.rowActive : styles.row, styles[chatCat]].join(' ')}
      >
        <MessageCount count={waitingMessageCount} />
        <div className={styles.rowLeft}>
          <div className={styles.username}>
            <span className={styles.userFullName}>
              {subscriber && subscriber.trim() ? subscriber : 'Unknown guest'}
            </span>
            <span className={styles.messageTime}>
              {moment(lastMessageOn).format('h:mm A')}
            </span>
          </div>
          <div className={styles.preview}>
            {lastMessageBotIntent &&
              goodDialogFromIntents.includes(lastMessageBotIntent) && (
                <span className={styles.intent}>
                  {dialogFlowIntentNames[lastMessageBotIntent]}
                </span>
              )}
            <Preview active={active} lastMessage={lastMessage} ownedBy={ownedBy} />
          </div>
        </div>
        <div className={styles.rowRight}>
          {roomNumber && (
            <div
              className={styles.room}
              title={isCheckedOut ? 'Checked out' : 'In-property'}
            >
              <div className={styles.rowRightIcon}>
                {isCheckedOut ? <RoomOffIcon /> : <RoomOnIcon />}
              </div>
              <span>{roomNumber}</span>
            </div>
          )}
          <LoyaltyIcon
            className={styles.loyaltyIcon}
            loyaltyLevel={loyaltyLevel}
            loyaltyProgram={loyaltyProgram}
          />
        </div>
      </div>
    </Link>
  )
}

ConversationRow.propTypes = {
  subscriber: PropTypes.string.isRequired,
  lastMessage: PropTypes.string,
  roomNumber: PropTypes.string,
  lastMessageOn: PropTypes.string,
  active: PropTypes.bool,
  waitingMessagesCount: PropTypes.number,
  waitTime: PropTypes.number,
  isCheckedOut: PropTypes.bool
}

export default ConversationRow
